var _componentDaterange = function() {
    if (!$().daterangepicker) {
        console.warn('Warning - daterangepicker.js is not loaded.');
        return;
    }

    // Single picker
    $('.js-daterange-single').daterangepicker({ 
        singleDatePicker: true,
        locale: {
            format: 'DD/MM/YYYY'
        }
    });
};

var _componentAnytime = function() {
    if (!$().AnyTime_picker) {
        console.warn('Warning - anytime.min.js is not loaded.');
        return;
    }

    // On demand picker
    $('.js-anytime-ondemand-timepicker').on('click', function (e) {
        $('#' + $(this).data('demand')).AnyTime_noPicker().AnyTime_picker({
            format: '%H:%i',
            labelTitle: 'Zeit wählen',
            labelHour: 'Stunden',
            labelMinute: 'Minuten'
        }).focus();
        e.preventDefault();
    });
};

function init() {
    _componentDaterange();
    _componentAnytime();
}


export const DateTimePickers = {
    init
}